import { render, staticRenderFns } from "./FormAuthorityConfig.vue?vue&type=template&id=36c9bf2e&scoped=true"
import script from "./FormAuthorityConfig.vue?vue&type=script&lang=js"
export * from "./FormAuthorityConfig.vue?vue&type=script&lang=js"
import style0 from "./FormAuthorityConfig.vue?vue&type=style&index=0&id=36c9bf2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9bf2e",
  null
  
)

export default component.exports